import { Box, Flex, Progress } from '@radix-ui/themes';
import { RADIX, RadixColor } from 'lib_ts/enums/radix-ui';
import { ReactNode } from 'react';

interface IProps {
  // 0-100
  value: number;
  color?: RadixColor;
  leftLabel?: ReactNode;
  rightLabel?: ReactNode;
  paused?: boolean;
  hidden?: boolean;
}

export const CommonProgress = (props: IProps) => {
  const hasLabels = !!props.leftLabel || !!props.rightLabel;
  return (
    <Flex hidden={props.hidden} direction="column" gap={RADIX.FLEX.GAP.SM}>
      <Progress
        color={props.paused ? RADIX.COLOR.WARNING : props.color}
        value={props.value}
      />

      {hasLabels && (
        <Flex align="center">
          {props.leftLabel && <Box>{props.leftLabel}</Box>}
          <Box flexGrow="1">{/* placeholder */}</Box>
          {props.rightLabel && <Box>{props.rightLabel}</Box>}
        </Flex>
      )}
    </Flex>
  );
};
